import type { ArtworkRecord } from '../../../../../packages/contracts/src/search.js';
import { React } from '../../shared/react.js';
import { Icon } from '../../shared/icons.js';
import { ArtworkImage } from '../../shared/ui/ArtworkImage.js';

export function QueryNode(props: {
  readonly artwork: ArtworkRecord | null;
  readonly uploadedPreviewUrl: string | null;
  readonly queryText: string;
  readonly busy: boolean;
  readonly onSelect: () => void;
}) {
  const imageUrl = props.uploadedPreviewUrl ?? props.artwork?.thumbnailUrl ?? props.artwork?.imageUrl;
  return (
    <button type="button" className={`query-node${props.busy ? ' is-busy' : ''}`} onClick={props.onSelect} aria-label="Inspect the current query">
      <span className="query-node__label">Your query</span>
      <span className="query-node__frame">
        {imageUrl ? (
          <ArtworkImage src={imageUrl} alt="" eager fallbackLabel="Query" width={props.artwork?.imageWidth} height={props.artwork?.imageHeight} dominantColor={props.artwork?.dominantColor}/>
        ) : (
          <span className="query-node__text" aria-label={props.queryText}>
            <Icon name="search" size={20}/>
            <strong>{props.queryText}</strong>
            <small>text query</small>
          </span>
        )}
      </span>
    </button>
  );
}
